import { GET, POST, PUT, DELETE } from './api'

export const Create = async (params) => {
    return await POST(`/users`, params, true);
}

export const Read = async (id) => {
    return await GET(`/users?filters[currentCompany]=${id}&_limit=-1&populate=*&pagination[pageSize]=1000`, true);
}

export const ReadOne = async (id) => {
    return await GET(`/users/${id}?populate=*`, true);
}

export const ReadByEmail = async (email) => {
    return await GET(`/users?filters[email]=${email}`, true);
}

export const Update = async (params, id) => {
    return await PUT(`/users/${id}`, params, true);
}

export const Delete = async (id) => {
    return await DELETE(`/users/${ id }`, true);
} 
 